import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import StackedTeaser from '../atoms/StackedTeaser'

const QuadrupleTeaserBlock = ({ block, className }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`quadruple-teaser-block ${className} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <div className="quadruple-teaser-block-container">
          <div className="quadruple-teaser-block-wrapper">
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
            />

            <div className="quadruple-teaser-block-row justify-content-start">
              {block.teaser?.length > 0 &&
                block.teaser.map((item, index) => (
                  <StackedTeaser
                    className="stacked-teaser-item-card"
                    item={item}
                    key={index}
                  />
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default QuadrupleTeaserBlock
